/**
 * Collect living allied minion domains plus the local champ for team FoW.
 */
export function listAlliedMinionViewers(championEntity, activeMinions = []) {
  const viewers = championEntity ? [championEntity] : [];
  if (!championEntity) return viewers;
  for (const row of activeMinions) {
    const unit = row?.domain;
    if (!unit || unit.isDead || unit.team !== championEntity.team) continue;
    viewers.push(unit);
  }
  return viewers;
}

/** Living allied minions + champs for FoW clear disks (excludes self). */
export function listAlliedFowDiskViewers(
  championEntity,
  activeMinions = [],
  alliedChamps = []
) {
  if (!championEntity) return [];
  const extras = [];
  for (const row of activeMinions) {
    const unit = row?.domain ?? row;
    if (!unit || unit.isDead || unit.team !== championEntity.team) continue;
    extras.push(unit);
  }
  for (const champ of alliedChamps) {
    if (!champ || champ === championEntity || champ.isDead) continue;
    if (champ.team !== championEntity.team) continue;
    extras.push(champ);
  }
  return extras;
}
